/** Appeal submission channel values for case appeals. */
export enum AppealType {
  FAX = "fax",
  PHONE = "phone",
  PORTAL = "portal",
  MAIL = "mail",
}

/** Human-readable labels for {@link AppealType} values. */
export const AppealTypeLabels: Record<AppealType, string> = {
  [AppealType.FAX]: "Fax",
  [AppealType.PHONE]: "Phone",
  [AppealType.PORTAL]: "Portal",
  [AppealType.MAIL]: "Mail",
};
